export default __webpack_public_path__ + "static/media/footerLogo.05dca20d.svg";